// Meta (Facebook) pixel. The server stamps the ID into the page
// (window.__HDDN_PIXEL__, from META_PIXEL_ID in api-server.js); with no ID the
// pixel never loads, so local and preview builds stay untracked. The admin
// dashboard is never tracked.

import { onAdminHost, isAdminPath } from './hosts.js';

function pixelId() {
  return (typeof window !== 'undefined' && window.__HDDN_PIXEL__) || '';
}

function adminView() {
  return onAdminHost() || isAdminPath(window.location.pathname);
}

export function initMetaPixel() {
  const id = pixelId();
  if (!id || window.fbq || adminView()) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
  document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', id);
  window.fbq('track', 'PageView');
}

// A completed booking, as Meta's standard "Schedule" event. The booking ref
// becomes the eventID so a reload of the confirmation doesn't count twice.
export function trackBooking(bookingRef, valueDollars) {
  if (!window.fbq || adminView()) return;
  const params = { currency: 'USD' };
  if (Number(valueDollars) > 0) params.value = Number(valueDollars);
  window.fbq('track', 'Schedule', params, bookingRef ? { eventID: `booking-${bookingRef}` } : undefined);
}
